/**
 * Text Element Schema
 */

import type { ElementSchema, TextFieldSchema, SelectFieldSchema } from '@ai-content-hub/content-kit';

export const defaultTextElementI18n = {
    en: { enterText: 'Enter your text here...' },
    vi: { enterText: 'Nhập văn bản của bạn...' },
};

export interface TextElementData {
    text: string;
    variant: 'body' | 'heading' | 'caption' | 'label';
    alignment: 'left' | 'center' | 'right';
}

export const textElementSchema: ElementSchema<TextElementData> = {
    type: 'element-text',
    title: 'Text Block',
    description: 'Plain text content for paragraphs, headings, and labels',
    version: '1.0.0',
    category: 'text',
    icon: 'Type',
    tags: ['text', 'paragraph', 'heading', 'content'],
    fields: [
        {
            name: 'text',
            type: 'text',
            label: '',
            placeholder: 'Enter your text here...',
            required: true,
            multiline: true,
        } as TextFieldSchema,
        {
            name: 'variant',
            type: 'select',
            label: 'Variant',
            defaultValue: 'body',
            options: [
                { value: 'body', label: 'Body Text' },
                { value: 'heading', label: 'Heading' },
                { value: 'caption', label: 'Caption' },
                { value: 'label', label: 'Label' },
            ],
        } as SelectFieldSchema,
        {
            name: 'alignment',
            type: 'select',
            label: 'Alignment',
            defaultValue: 'left',
            options: [
                { value: 'left', label: 'Left' },
                { value: 'center', label: 'Center' },
                { value: 'right', label: 'Right' },
            ],
        } as SelectFieldSchema,
    ],
    defaultData: {
        text: '',
        variant: 'body',
        alignment: 'left',
    },
    i18n: defaultTextElementI18n,
};

